/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const availabilityRangeResponseSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  endDate: z.iso.date().nullish(),
  fridayDuration: z.int(),
  id: z.int(),
  mondayDuration: z.int(),
  name: z.string().nullish(),
  observanceRule: z.string(),
  organizationId: z.string(),
  priority: z.string().nullish(),
  saturdayDuration: z.int(),
  schemeId: z.int(),
  sourceId: z.string().nullish(),
  startDate: z.iso.date().nullish(),
  sundayDuration: z.int(),
  thursdayDuration: z.int(),
  tuesdayDuration: z.int(),
  type: z.string(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string().nullish(),
  wednesdayDuration: z.int(),
});
